export default {
  configureAjax() {
    if (!this.ajax) return;
    this.perPage = this.config.perPage;
    this.textField = this.config.textField;
    this.valueField = this.config.valueField;
    this.collectionRoot = this.config.ajaxCollectionRoot;
  },
  fetchAjax(params) {
    const deferred = $.Deferred();

    $.ajax({
      url: this.ajaxUrl,
      method: 'GET',
      dataType: 'json',
      data: params,
      success: (data) => {
        deferred.resolve(data);
      },
      error: (xhr, textStatus, err) => {
        deferred.reject({xhr, textStatus, err});
      }
    });

    return deferred.promise();
  }
};
